import { useMemo } from "react";
import { buildParticles, holidayGreeting, iconMarkup } from "../../lib/holidays";

export function HolidayIcon({ name, color, size = 24, className = "", style }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      className={className}
      style={{ color, ...style }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: iconMarkup(name) }}
    />
  );
}

export function HolidayBanner({ theme, settings }) {
  const [c1, c2] = theme.colors;
  const greeting = holidayGreeting(settings, theme);
  return (
    <div
      data-testid="holiday-banner"
      data-holiday={theme.id}
      className="relative overflow-hidden text-white"
      style={{ background: `linear-gradient(90deg, ${c1}, ${c2}, ${c1})` }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-5 py-2.5 sm:gap-5">
        <HolidayIcon name={theme.icons[0]} color="rgba(255,255,255,.9)" size={20} className="holiday-bob shrink-0" />
        <p className="truncate font-serif text-sm italic sm:text-base" data-testid="holiday-greeting">{greeting}</p>
        <HolidayIcon name={theme.icons[1] || theme.icons[0]} color="rgba(255,255,255,.9)" size={20} className="holiday-bob shrink-0" style={{ animationDelay: "-1.2s" }} />
      </div>
    </div>
  );
}

export function HolidayParticles({ theme }) {
  const particles = useMemo(() => buildParticles(theme), [theme]);
  return (
    <div className="holiday-particles" data-testid="holiday-particles" data-holiday={theme.id} data-motion={theme.motion} aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          className={`holiday-particle ${p.id % 2 ? "hidden sm:block" : ""}`}
          style={{ left: `${p.left}%`, "--dur": `${p.duration}s`, "--delay": `${p.delay}s`, "--sway": `${p.sway}vw` }}
        >
          <HolidayIcon name={p.icon} color={p.color} size={p.size} className="holiday-sway" style={{ animationDuration: `${p.duration / 4}s` }} />
        </span>
      ))}
    </div>
  );
}

export function HolidayHeroDecor({ theme }) {
  const [c1, c2] = theme.colors;
  return (
    <div
      className="pointer-events-none absolute inset-0"
      data-testid="holiday-hero-tint"
      style={{ background: `radial-gradient(60% 70% at 85% 10%, ${c1}2e, transparent 70%), radial-gradient(50% 60% at 5% 90%, ${c2}26, transparent 70%)` }}
    />
  );
}
